

function KPICard({ label, value, subtitle, subtitle2, icon, color = 'blue', badge, onClick }) {
  const colors = {
    blue: 'bg-blue-50 border-blue-100 text-blue-700',
    emerald: 'bg-emerald-50 border-emerald-100 text-emerald-700',
    amber: 'bg-amber-50 border-amber-100 text-amber-700',
    red: 'bg-red-50 border-red-100 text-red-700',
    violet: 'bg-violet-50 border-violet-100 text-violet-700',
    teal: 'bg-teal-50 border-teal-100 text-teal-700',
    indigo: 'bg-indigo-50 border-indigo-100 text-indigo-700',
    slate: 'bg-slate-50 border-slate-200 text-slate-700',
  };
  const iconColors = {
    blue: 'text-blue-400', emerald: 'text-emerald-400', amber: 'text-amber-400',
    red: 'text-red-400', violet: 'text-violet-400', teal: 'text-teal-400',
    indigo: 'text-indigo-400', slate: 'text-slate-400',
  };
  return (
    <div className={`${colors[color]} border rounded-xl p-4 transition-all hover:shadow-md ${onClick ? 'cursor-pointer ring-0 hover:ring-2 hover:ring-offset-1 hover:ring-current/20' : ''}`}
      onClick={onClick}
      data-testid={`kpi-${label.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] font-bold uppercase tracking-wider opacity-60">{label}</span>
        <span className={iconColors[color]}>{icon}</span>
      </div>
      <div className="text-2xl font-bold">{typeof value === 'number' ? value.toLocaleString() : value}</div>
      {badge && <span className="text-[9px] font-semibold bg-white/60 rounded px-1.5 py-0.5 mt-1 inline-block">{badge}</span>}
      {subtitle && <div className="text-[11px] mt-1 opacity-70">{subtitle}</div>}
      {subtitle2 && <div className="text-[10px] mt-0.5 opacity-50">{subtitle2}</div>}
      {onClick && <div className="text-[8px] mt-1.5 opacity-40 font-medium">Click for details</div>}
    </div>
  );
}

export default KPICard;
